/**
@format
@flow
*/

type ColorTypes = {
  White: string,
  Black: string,
  PrimaryBlue: string,
  Cyan: string,
  BrandBlueDark: string,
  BrandBlueVeryDark: string,
  BrandBlueFaded: string,
  BrandCyan: string,
  Gray: string,
  GrayFaded: string,
  GrayLight: string,
  GrayVeryLight: string,
  GrayDark: string,
  GrayVeryDark: string,
  GrayVeryDarkFaded: string,
  SecondaryGreen: string,
  SecondaryRed: string,
  SecondaryRedDark: string,
  SecondaryRedLight: string,
};

const Colors: ColorTypes = {
  White: '#FFFFFF',
  Black: '#000000',

  // Brand Blues
  Cyan: '#43D7FC',
  PrimaryBlue: '#158DD4',
  BrandBlueDark: '#005CA2',
  BrandBlueVeryDark: '#004182',
  BrandBlueFaded: '#CEEAFA',
  BrandCyan: '#44D7FC',

  // Grays
  Gray: '#7A8899',
  GrayFaded: '#F5F6FA',
  GrayLight: '#D3D9E0',
  GrayVeryLight: '#E5EAF0',
  GrayDark: '#606C7A',
  GrayVeryDark: '#242B33',
  GrayVeryDarkFaded: '#3B3B3B',

  // Secondary
  SecondaryGreen: '#0FAA8D',
  SecondaryRed: '#E94B3B',
  SecondaryRedDark: '#A33329',
  SecondaryRedLight: '#F08275',
};

export default Colors;
